"use strict";

angular.module("core")
.service("ReadOnlyPermissionService", function(UserService, ModalService, FlashBag) {
    var _this = this;

    this.handleResponseError = function(response) {
        if (response.status !== 403) {
            return;
        }

        return UserService.isUserFetched().then(function onSuccess(user) {
            if (user && user.info && user.info.is_user_customer_readonly) {
                return openModal();
            }
        });
    };

    this.responseErrorInterceptor = function(response) {
        _this.handleResponseError(response);
        return FlashBag.responseErrorInterceptor(response);
    };

    function openModal() {
        return ModalService.showModal({
            templateUrl: require("./modal/readonly-permission.modal.html"),
            controller: "ReadonlyPermissionModalController",
            controllerAs: "readonlyPermissionModalCtrl"
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function(e) {
                modal.element.remove();
            });
            return modal.close;
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/readonly-permission/readonly-permission.service.js
// module id = 446
// module chunks = 0